import _extends from "@babel/runtime/helpers/extends";
import React, { memo } from 'react';
import classNames from 'classnames/bind';
import { Text } from '@beef/ui-kit';
import { Title } from "./..";
import { CommonCard } from "./CommonCard";
import style from "./styles.module.pcss";
var cn = classNames.bind(style);
export var LayoutCard = /*#__PURE__*/memo(function (_ref) {
  var _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'imageCard' : _ref$type,
    _ref$content = _ref.content,
    content = _ref$content === void 0 ? [] : _ref$content,
    title = _ref.title,
    text = _ref.text,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 's' : _ref$size,
    onClick = _ref.onClick,
    withBorders = _ref.withBorders,
    _ref$blockIndex = _ref.blockIndex,
    blockIndex = _ref$blockIndex === void 0 ? 0 : _ref$blockIndex;
  return /*#__PURE__*/React.createElement(React.Fragment, null, title && /*#__PURE__*/React.createElement(Title, {
    isWithSubtitle: !!text,
    "data-t-id": "components-LayoutCard"
  }, title), text && /*#__PURE__*/React.createElement(Text, {
    className: cn('text'),
    color: "grey60",
    size: "size4-r"
  }, text), /*#__PURE__*/React.createElement("div", {
    className: cn('container', "container--".concat(size))
  }, (content === null || content === void 0 ? void 0 : content.length) > 0 && content.map(function (card, index) {
    return /*#__PURE__*/React.createElement(CommonCard, _extends({}, card, {
      blockIndex: blockIndex,
      index: index,
      key: index,
      onClick: onClick,
      size: size,
      type: type,
      withBorders: withBorders
    }));
  })));
});